import {Button, Grid, TextField} from "@mui/material";
import {useEffect, useState} from "react";
import {API} from "../framework/api";
import {getUserHash, invalidateUser} from "../framework/utils";
import {TXT_SUBTITLE} from "../framework/constants";
import {confirmAlert} from "react-confirm-alert";
import {Menu} from "../component/Menu";
import {MENU_ITEMS} from "../framework/constants";
import {CompetenceArea} from "../component/CompetenceArea";

export function ProfilePage(props) {
  const [values, setValues] = useState({
    username: '',
    competences: '',
    email: '',
    freeText: '',
    experience: '',
  });

  useEffect(() => {
    const {username, hash} = getUserHash();
    API.getAPI().get_user_info(username).then((response)=> {
      setValues({ ...values,
        username,
        competences: (response.data.competences ?? ''),
        email: (response.data.email ?? ''),
        freeText: (response.data.freeText ?? ''),
        experience: (response.data.experience ?? ''),
      });
    }).catch((e) => {
      confirmAlert({
        title: "Felaktig inloggning",
        message: "Inloggningen misslyckades. Kontrollera dina inloggningsuppgifter och försök igen.",
        buttons: [{
          label: "Avfärda",
          onClick: () => { window.location.hash="#/login"; }
        }]
      });
      console.error(e);
    });
  }, []);

  const handleChange = (event, prop) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const updateCompetences = (id, hasIt) => {
    let sep = "";
    let cStr = "";

    let comp = {};
    values.competences.split(",").forEach((c) => {
      if (parseInt(c) !== parseInt(id)) comp[parseInt(c)] = true;
    });

    if (hasIt) {
      comp[parseInt(id)] = true;
    }

    Object.keys(comp).forEach(k => {
      cStr += sep + k;
      sep = ',';
    });
    setValues({ ...values, competences: cStr });
  }

  const handleSaveSettings = () => {
    API.getAPI().user_update(values).then(()=> {
      confirmAlert({
        title: "Profilen sparad",
        message: "Din profil har sparats.",
        buttons: [{
          label: "Ok",
          onClick: () => {}
        }]
      });
    }).catch((e) => {
      let msg = "Kontot kunde inte uppdateras. Kontrollera dina kontouppgifter och försök igen. ";
      if (e.response && e.response.data && e.response.data.message) {
        msg += `Servern rapporterade: '${e.response.data.message}'.`;
      }
      confirmAlert({
        title: "Konto kunde inte uppdateras",
        message: msg,
        buttons: [{
          label: "Avfärda",
          onClick: () => {}
        }]
      });
      console.error(e);
    });
  }

  const handleLogout = () => {
    invalidateUser();
    window.location.hash="#/login";
  }

  return (
    <div>
      <div className={"App-title-withSubtitle"}>Välkommen till anslagstavlan</div>
      <div className={"App-subTitle"}>{TXT_SUBTITLE}</div>
      <Grid container={true} spacing={0} className={"App-drop-shadow"}>
        <Grid item xs={12} md={3} className={"App-container-leftMenu"}>
          <Menu items={MENU_ITEMS} />
        </Grid>
        <Grid item xs={12} md={9} className={"App-container-rightContent"}>
          <div className={"App-rightContent"}>
            <Grid container={true} spacing={0}>

              {/*** App Right content ***/}

              <Grid item xs={12} sm={12}>
                <div className={"App-fieldTitle"}>Användarnamn</div>
              </Grid>

              <Grid item xs={12} sm={12}>
                {values.username}
              </Grid>

              <Grid item xs={12} sm={12}>
                <div className={"App-fieldTitle"}>Fyll i dina kunskaper</div>
              </Grid>

              <Grid item xs={12} sm={12}>

                {/*** Competences ***/}
                <CompetenceArea competences={values.competences} onChange={(id, hasIt) => { updateCompetences(id, hasIt) }} />

              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={"App-fieldTitle"}>Fyll i din erfarenhet</div>
              </Grid>
              <Grid item xs={12} sm={12}>

                <TextField
                  multiline={true}
                  minRows={6}
                  placeholder="T.ex. 5 år inom..."
                  style={{ minWidth: '100%' }}
                  value={values.experience}
                  onChange={(e)=> handleChange(e, 'experience')}
                />

              </Grid>

              <Grid item xs={12} sm={12}>
                <div className={"App-fieldTitle"}>Få uppdateringar när vi hittat en matchning? Fyll i din mailadress.</div>
              </Grid>
              <Grid item xs={12} sm={12}>

                {/*** Email (frivilligt) ***/}

                <TextField
                  fullWidth={1}
                  type="email"
                  id="outlined-basic"
                  label="E-post (frivilligt)"
                  variant="outlined"
                  value={values.email}
                  onChange={(e)=> handleChange(e, 'email')}
                />
              </Grid>

              <Grid item xs={12} sm={12} className={"u-textRight u-marginT20"}>

                <Button
                  className={"App-button-text"}
                  variant={"text"}
                  onClick={handleLogout}
                >
                  Logga ut
                </Button>

                <Button
                  className={"App-button-contained"}
                  variant={"contained"}
                  onClick={handleSaveSettings}
                >
                  Spara
                </Button>
              </Grid>

            </Grid>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
